export const GET_APP_USER_REQUEST = 'GET_APP_USER_REQUEST';
export const GET_APP_USER_SUCCESS = 'GET_APP_USER_SUCCESS';
export const GET_APP_USER_FAILURE = 'GET_APP_USER_FAILURE';
export const GET_APP_USER_RESET = 'GET_APP_USER_RESET';
